// @flow

import React, { Component } from "react"
import { BrowserRouter, Route, Switch } from "react-router-dom"
import { connect } from "react-redux"

import App from "./views/App"
import Login from "./views/Login"
import PasswordRecovery from "./views/PasswordRecovery"
import NotFound from "./views/NotFound"


class Routes extends Component {
  props: {
    auth: any
  }

  render () {
    const { auth } = this.props

    return (
      <BrowserRouter {...this.props}>
        <Switch>
          <Route exact path="/login" component={Login} />
          <Route exact path="/passwordRecovery" component={PasswordRecovery}/>
          <Route path="/" component={auth.ok !== true ? Login : App} />
          <Route component={NotFound} />
        </Switch>
      </BrowserRouter>
    )
  }
}

const mapStateToProps = ( state ) => {
  return {
    auth: state.auth,
  }
}

export default connect( mapStateToProps, null )( Routes )



// WEBPACK FOOTER //
// ./src/router.jsx